/* eslint-disable @typescript-eslint/no-duplicate-enum-values -- some query string keys are shared; we want to refer to them semantically */
export enum QueryStringKey {
  ONLINE_JOINING_ENCODED_CONTACT_ID = 'c',
  ONLINE_JOINING_EXISTING_CONTACT_AUTH_TOKEN = 'a',
  ONLINE_JOINING_SOURCE = 's',
  ONLINE_JOINING_PROMO_CODE = 'offer',
  ONLINE_JOINING_COUNTRY_SECTION_LANGUAGE = 'lang',
  ONLINE_JOINING_FRIENDS_AND_FAMILY_REFERRAL_CODE = 'referral',
  ONLINE_JOINING_IN_CLUB_SIGNUP = 'signupRef',
  ONLINE_JOINING_SALES_APPOINTMENT = 'appointment',

  DIGITAL_SIGNATURE_ENCODED_CONTACT_ID = 'c',
  DIGITAL_SIGNATURE_AUTH_TOKEN = 'a',

  CONTACT_VERIFICATION_ENCODED_CONTACT_ID = 'c',

  LIVE_STREAM_CLASS_INSTANCE_ID = 'c',
  LIVE_STREAM_SITE_ID = 's',
  LIVE_STREAM_VIDEO_ID = 'v',
  LIVE_STREAM_VIMEO_RECURRING_EVENT = 'e',
  LIVE_STREAM_VIMEO_OTT = 'ott',

  QUICK_REGISTRATION_AUTHORISATION_GUID = 'authGuid',

  BAT_SHORTHAND_ENCODED_CONTACT_ID = 'c',
  BAT_SOURCE = 's',
  BAT_CONTACT_ID = 'contactId',
  BAT_CONTACT_TYPE = 'contactType',
  BAT_EXISTING_CONTACT_AUTH_TOKEN = 'a',

  MANAGE_TOUR_BOOKING_ID = 'id',
  MANAGE_TOUR_AUTH_TOKEN = 'authToken',
}
